import { defineComponent as _defineComponent } from 'vue'
import {onBeforeMount, onMounted, ref, watch} from 'vue'
import { useRouter } from 'vue-router';
import { DataInstance, Meetings, Userspaces } from '@busy-human/opt-library'
import meetingPopup from "./meeting-details/meeting-details.vue"
import VPaidIcon from '@/components/paid-icon.vue'
import { useUserspace } from '@/store/userspace';

type Props = {
    previous?: Boolean
    meeting: DataInstance<Meetings.Model>
}
type Emits = {
    (e: "handle:showPopup", value: DataInstance<Meetings.Model>): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'upcomingMeeting',
  props: {
    previous: null,
    meeting: null
  },
  emits: ["handle:showPopup"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "handle:showPopup", value: DataInstance<Meetings.Model>): void,
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    previous?: Boolean
    meeting: DataInstance<Meetings.Model>
}



const router = useRouter();
const month = ref("")
const day = ref("")
const meetingDate = ref("")
const meetingTime = ref("")
const meetingDuration = ref(0)
const meetingLink = ref("")
const recipientName = ref("")
const youPayMe = ref(false)
const meetingLocation = ref("")
const city = ref("")
const state = ref("")
const payout = ref(false)


watch(() => props.meeting, async meeting => {
    if(meeting) {
        let meetingStartTime = new Date(props.meeting.startTime)
        meetingLocation.value = meeting.location.type
        if(meetingLocation.value === 'physical'){
            city.value = meeting.location.fields.city
            state.value = meeting.location.fields.state
        }
        const dateOptions: Intl.DateTimeFormatOptions = {month: 'short', day: "numeric"}
        meetingDate.value = new Intl.DateTimeFormat('en-US', dateOptions).format(meetingStartTime);
        const tmp = meetingDate.value.split(" ")
        month.value = tmp[0]
        day.value = tmp[1]

        const timeOptions: Intl.DateTimeFormatOptions = {hour: 'numeric', minute: "numeric"}
        meetingTime.value = new Intl.DateTimeFormat('en-US', timeOptions).format(meetingStartTime);

        let meetingEndTime = new Date(props.meeting.endTime)

        meetingDuration.value = (meetingEndTime.valueOf() - meetingStartTime.valueOf()) / 60000

        const currentUser = useUserspace().user
        if(currentUser.$id == meeting.collector){
            youPayMe.value = true
            meetingLink.value = meeting.collectorLink || '404'
            const recipient = await Userspaces.Collection.fetchDoc(meeting.payer)
            recipientName.value = recipient.data().name.fullName
        }else{
            meetingLink.value = meeting.payerLink || '404'
            const recipient = await Userspaces.Collection.fetchDoc(meeting.collector)
            recipientName.value = recipient.data().name.fullName
        }
       
    }
}, {immediate: true})

const handlePopup = () =>{
    emit("handle:showPopup",props.meeting)
}


const __returned__ = { props, emit, router, month, day, meetingDate, meetingTime, meetingDuration, meetingLink, recipientName, youPayMe, meetingLocation, city, state, payout, handlePopup, onBeforeMount, onMounted, ref, watch, useRouter, DataInstance, Meetings, Userspaces, meetingPopup, VPaidIcon, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})